import React, { Component } from "react";
import { connect } from "react-redux";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalCargarPresupuesto, cargarPresupuesto } from "../actions";

class ModalCargarPresupuesto extends Component {
  modalContent = () => {
    const buttons = [];
    if (this.props.elementos.some(x => x === "EcyU7Sr8")) buttons.push(<BoxButton key="ba[0][7]" name="check" title="Aceptar" disabled={this.props.saving} type="submit" />);

    const handleSubmit = e => {
      e.preventDefault();
      this.props.cargarPresupuesto();
    }

    return (
      <form id="form" onSubmit={handleSubmit} noValidate>
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-info">
                Incluya unicamente archivos con extension .xlsx con una única
                hoja la cual debe contener las siguientes columnas:{" "}
                <b>periodo</b>, <b>valor_total</b>, <b>valor_disponible</b> y{" "}
                <b>cenco</b>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="control-label">Seleccione un archivo</label>
                <Input type="file" reducer="cencos" path="modalCargarPresupuesto.data.file"/>
                <button type="submit">Subir</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCargarPresupuesto } = this.props;
    if (!modalCargarPresupuesto.get("show")) return null;

    return <Modal ancho="30vw" mostrar={modalCargarPresupuesto.get("show")} contenido={this.modalContent()} titulo="Cargue masivo de presupuestos" nombre="modal_upload_presupuestos" onCerrarModal={() => this.props.showHideModalCargarPresupuesto(false)} />
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCargarPresupuesto: state.cencos.get("modalCargarPresupuesto"),
    saving: state.cencos.get("saving"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCargarPresupuesto,
  cargarPresupuesto
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalCargarPresupuesto);
